import * as React from 'react';
import { ValueRanges } from 'rlv-common';
import {
  getTrackingBirthdate,
  mapFetchedNeedData,
  mapTrackingInsuredPerson,
} from '../../../../tracking/trackingFormating';

import { ViewName } from '../../../../helpers/ViewName';
import NeedsPageContainer from '../../../../pages/needs/NeedsPageContainer';
import { DecreasingNeedData } from '../../../../pages/needs/Needs.types';
import { getAngebot, updateDecreasingNeedBlockData } from '../../../../services/api';
import { PagePercentage } from '../../../../types/PagePercentage';
import { createNeedPageSchema } from '../../../../validation/NeedPage';
import { FetchedTrackingData, StateDefinition } from '../../../StateMachine';
import { NavigationAction, StateName } from '../../../StateMachineTypes';

export const decreasingSumInsuredState: StateDefinition<DecreasingNeedData> = {
  name: StateName.DECREASING_SUM_INSURED,
  percentage: PagePercentage.DECREASING_SUM_INSURED,
  trackingViewName: ViewName.BEDARFSANALYSE,
  createValidationSchema: (valueRanges: ValueRanges) => createNeedPageSchema(valueRanges),
  validInboundStates: [StateName.NEED_PAGE, StateName.DECREASING_YEARS_TERM],
  transitions: [
    {
      test: action => {
        const backAction =
          action === NavigationAction.BACK || action === NavigationAction.BROWSER_BACK;
        return backAction;
      },
      newState: StateName.NEED_PAGE,
    },
    {
      test: action => action === NavigationAction.NEXT,
      newState: StateName.DECREASING_YEARS_TERM,
    },
  ],
  onEnter: async (_, inputData) => {
    const response = await getAngebot(inputData.businessId);

    const fetchedTrackingData: FetchedTrackingData = {
      userAttributes: {
        ...mapTrackingInsuredPerson(),
        ...getTrackingBirthdate(response.livingConditionsModel),
      },
      tariffOptions: {
        ...mapFetchedNeedData(response.needSelectionModel),
      },
    };

    if (response.feeCalculationModel) {
      fetchedTrackingData.tariffOptions!.VersSumEJ = response.feeCalculationModel.sumInsured;
    }

    return {
      userInput: response.decreasingNeedModel,
      valueRanges: response.valueRanges,
      fetchedTrackingData,
    };
  },
  onExit: async (_, inputData) => {
    await updateDecreasingNeedBlockData(inputData.businessId, inputData.userInput);
    return {};
  },

  render: (inputData, handleAction, updateApp, _unused, updateDTMTracking) => {
    const userInput: DecreasingNeedData = inputData.userInput;
    return (
      <NeedsPageContainer
        businessId={inputData.businessId}
        inputData={inputData}
        updateApp={updateApp}
        storeState={{
          sumInsured: userInput.sumInsured,
          // We need to send this values to the tracker
          periodInYears: userInput.periodInYears,
          insuranceEndSum: userInput.insuranceEndSum,
          update: values => updateApp(values),
        }}
        valueRanges={inputData.valueRanges}
        handleAction={handleAction}
        updateDTMTracking={updateDTMTracking}
      />
    );
  },
};
